//
//
//
//
//
//
//
//
//
export default {
  mixins: [],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      series: []
    };
  },
  methods: {
    $ready: function $ready() {
      this.series = this.spec.dataSeries.reduce(function (prev, curr) {
        var obj = {};
        obj[curr.title] = curr.value;
        return Object.assign(prev, obj);
      }, {});
    }
  }
};